import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let routes = []

// 扫描child文件夹，将路由信息整合
const routerContext = require.context('../child', true, /index\.js$/)
routerContext.keys().forEach(route => {
  // 如果是根目录的 index.js、 不做任何处理
  if (route.startsWith('./index')) {
    return
  }
  // 如果不包含router文件夹，不加入
  if (route.indexOf('router') < 0) {
    return
  }
  const routerModule = routerContext(route)
  // 兼容 import export 和 require module.export 两种规范 Es modules commonjs
  routes = [...routes, ...(routerModule.default || routerModule)]
})
routes.push({
  // 刷新页面
  path: '/redirect/:path*',
  name: 'redirect',
  component: () => import('../views/redirectPage/index.vue')
})


export default new Router({
  mode: 'history',
  base: '/fes/',
  routes: routes
})
